import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createIntlCache } from "@formatjs/intl/lib/src/utils";
/**
 * @deprecated use `useLocalizationCacheStore` or `withStores` instead
 */ export var LocalizationCacheStore = function LocalizationCacheStore() {
    "use strict";
    var _this = this;
    _class_call_check(this, LocalizationCacheStore);
    this._cachedIntl = {};
    this.cache = createIntlCache();
    this.setCachedIntl = function(locale, intl) {
        _this._cachedIntl[locale] = {
            intl: intl
        };
    };
    this.getCachedIntl = function(locale) {
        return _this._cachedIntl[locale];
    };
};
LocalizationCacheStore.get = singletonGetter(LocalizationCacheStore, {
    globalSingleton: getGlobalProperty("isMainThread")
});
